var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 13.5714H22.2188M13.1339 9V10.3716M22.6875 9V10.3714M25.5 13.3714L25.5 22C25.5 23.6569 24.1569 25 22.5 25H13.5C11.8431 25 10.5 23.6569 10.5 22V13.3714C10.5 11.7146 11.8431 10.3714 13.5 10.3714H22.5C24.1569 10.3714 25.5 11.7146 25.5 13.3714Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.993a7d64f0c7b3e9542a52e9c169eaba.svg";
export { ForwardRef as ReactComponent };